import React from "react";

// Texto predeterminado para los casos en que el vehículo actual del usuario
// tiene mejor rendimiento que el modelo Toyota: en vez de mostrar una pérdida
// en rojo, se sugiere comparar contra modelos de la misma categoría.
const SUGGESTION_TEXT =
    "te recomendamos siempre hacer la comparativa con modelos que correspondan " +
    "a la misma categoría de tu vehículo actual, para que los valores resulten " +
    "más equiparables.";

const SuggestionCallout = () => (
    <div className="savings-calculator__callout">
        <svg
            className="savings-calculator__callout-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
            focusable="false"
        >
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
        <p className="savings-calculator__callout-text">
            <strong>Sugerencia:</strong> {SUGGESTION_TEXT}
        </p>
    </div>
);

export default SuggestionCallout;
